export type Direction = 'rtl' | 'ltr';

export interface LocaleMetadata {
  code: string;
  name: string;
  nativeName: string;
  direction: Direction;
}

export const SUPPORTED_LOCALES: Record<string, LocaleMetadata> = {
  ar: {
    code: 'ar',
    name: 'Arabic',
    nativeName: 'العربية',
    direction: 'rtl',
  },
  en: {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    direction: 'ltr',
  },
};

